import { Clock, Instagram, MapPin, Phone } from "lucide-react";
import Reveal from "./Reveal";

const INTERIOR = "/interior.png";
const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=11221+Merritt+St,+Castroville,+CA+95012";

export default function Visit() {
  return (
    <section
      id="visit"
      data-testid="visit-section"
      className="bg-deep py-24 text-cream lg:py-32"
    >
      <div className="mx-auto grid max-w-6xl items-center gap-16 px-5 lg:grid-cols-2">
        <div>
          <Reveal>
            <p className="font-editorial text-sm font-semibold italic tracking-[0.3em] text-gold">
              03 — COME SAY HI
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-display text-4xl font-bold leading-[1.02] sm:text-5xl lg:text-6xl">
              Pull up a chair{" "}
              <span className="font-editorial font-semibold italic text-gold">
                at the Giant.
              </span>
            </h2>
          </Reveal>

          <Reveal delay={0.16}>
            <div
              data-testid="hours-card"
              className="mt-9 rounded-3xl border border-cream/10 bg-cream/5 p-7"
            >
              <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-gold">
                <Clock className="h-4 w-4" /> Hours
              </div>
              <ul className="mt-5 space-y-4 text-base">
                <li className="flex items-baseline gap-3">
                  <span className="font-semibold">Monday – Friday</span>
                  <span className="flex-1 border-b border-dotted border-cream/20" />
                  <span
                    data-testid="hours-weekday"
                    className="whitespace-nowrap font-editorial text-lg font-semibold text-gold"
                  >
                    7:00 AM – 6:00 PM
                  </span>
                </li>
                <li className="flex items-baseline gap-3">
                  <span className="font-semibold">Saturday – Sunday</span>
                  <span className="flex-1 border-b border-dotted border-cream/20" />
                  <span
                    data-testid="hours-weekend"
                    className="whitespace-nowrap font-editorial text-lg font-semibold text-gold"
                  >
                    8:00 AM – 6:00 PM
                  </span>
                </li>
              </ul>
              <p className="mt-5 text-sm text-cream/55">
                Breakfast served ’til 10:30 AM · Lunch specials 11:30 AM – 2:30 PM
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.22}>
            <div className="mt-6 flex items-start gap-3 text-cream/80">
              <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
              <div>
                <p data-testid="visit-address" className="font-semibold">
                  11221 Merritt St, Castroville, CA 95012
                </p>
                <a
                  data-testid="visit-directions-link"
                  href={MAPS_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm font-semibold text-gold underline decoration-dotted underline-offset-4 transition-colors hover:text-cream"
                >
                  Get directions
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.28}>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                data-testid="visit-call-button"
                href="tel:8316334259"
                className="inline-flex items-center gap-2.5 rounded-full bg-gold px-7 py-3.5 font-display text-base font-semibold text-chalk transition-all hover:-translate-y-0.5 hover:brightness-105"
              >
                <Phone className="h-4 w-4" />
                (831) 633-4259
              </a>
              <a
                data-testid="visit-instagram-link"
                href="https://instagram.com/giantartichokecafe"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2.5 rounded-full border-2 border-cream/25 px-7 py-3.5 font-display text-base font-semibold text-cream transition-all hover:border-gold hover:text-gold"
              >
                <Instagram className="h-4 w-4" />
                @giantartichokecafe
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="relative">
          <div className="-rotate-1 overflow-hidden rounded-[2.5rem] border-8 border-cream/10 shadow-2xl">
            <img
              src={INTERIOR}
              alt="Inside Giant Artichoke Cafe and Grill"
              className="h-[380px] w-full object-cover sm:h-[500px]"
              data-testid="visit-interior-photo"
            />
          </div>
          <img
            src="/logo.png"
            alt=""
            data-testid="visit-logo-stamp"
            className="absolute -right-4 -top-8 h-28 w-28 rotate-6 rounded-full shadow-xl ring-4 ring-deep sm:h-32 sm:w-32"
          />
        </Reveal>
      </div>
    </section>
  );
}
